import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ErrorDialogMessage } from '../../../../model/src/lib/error-dialog-message.model';
@Component({
  selector: 'sigv-error-dialog',
  templateUrl: './error-dialog.component.html',
  styleUrls: ['./error-dialog.component.scss'],
})
export class ErrorDialogComponent implements OnInit {
  title?: string;
  errors: ErrorDialogMessage[] = [];
  lastIndex = 0;
  // 傳入錯誤訊息如有任一筆資料 errorMessage 有內容，應該已 2 欄呈現
  hasAnyErrorMessage = false;
  questionButton?: boolean;
  constructor(
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}

  ngOnInit(): void {
    const errors: ErrorDialogMessage[] = this.config.data?.errors;
    if (errors && errors.length > 0) {
      this.errors.push(...errors);
    }
    this.lastIndex = this.errors.length - 1;
    this.hasAnyErrorMessage = this.errors.some((err) => !!err.errorMessage);
    this.title = this.config.data?.title;
    this.questionButton = this.config.data?.questionButton;
  }

  close(result?: string): void {
    this.errors = [];
    this.ref.close(result);
  }
}
